import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { ModalRedeemCouponPage } from 'src/app/modals/modal-redeem-coupon/modal-redeem-coupon.page';
import { ModalRedeemInsurancePage } from 'src/app/modals/modal-redeem-insurance/modal-redeem-insurance.page';
import { AuthService } from 'src/app/services/auth.service';
import { ConfigService } from 'src/app/services/config.service';
import { ProductsService } from 'src/app/services/products.service';
import { ToolsService } from 'src/app/services/tools.service';

@Component({
  selector: 'app-target-product',
  templateUrl: './target-product.component.html',
  styleUrls: ['./target-product.component.scss'],
})
export class TargetProductComponent implements OnInit {
  @Input() product

  is_insurance = false

  missing_points = 0;
  missing_points_percentage = 0;
  progress_percentage = 0;

  quantity = 1

  money = 0
  points = 0
  rangeValue =  0;
  maxRangeValue = 0
  minRangeValue = 0

  constructor(
    public router: Router,
    public toolsService: ToolsService,
    public authService: AuthService,
    public productsService: ProductsService,
    public configService: ConfigService,
    public modalController: ModalController
  ) {
   }

  ngOnInit() {
    this.is_insurance = this.product.is_insurance
    this.getMissingPoints();
    this.loadPaymentOptions();
  }

  getProductCurrentPrice(product){
    return product.price - product.discount
  }

  loadPaymentOptions(){
    if(!this.authService.isLogged){
      return
    }
    var points_aux = this.product.price - this.product.discount
    if(this.authService.player_initial_data.points >= points_aux){
      this.rangeValue = 100
      this.points = this.product.price - this.product.discount
    }
    else {
      this.points = this.authService.player_initial_data.points
      let difference = this.getProductCurrentPrice(this.product) - this.points
      this.money = difference * this.configService.company_info.currency_value
      this.rangeValue = Math.round(this.points *100/points_aux)
    }
    this.maxRangeValue = this.rangeValue
    this.minRangeValue = this.productsService.validateMaxMoneyValue(100)

    if (this.minRangeValue > this.maxRangeValue){
      this.rangeValue = this.minRangeValue
      this.maxRangeValue = 100
    }
  }

  async changeLikedState(){
    if(this.authService.isLogged){
      try{
        this.productsService.changeLikedState(this.product.id);
        this.product.liked = !this.product.liked
      }catch(error){
        this.toolsService.showErrorToast()
        console.error('[PRODUCT-COMPONENT] changeLikedState()', error)
      }
    }
    else
      this.toolsService.showErrorToast("Debes ingresar para hacer esto")
  }

  openProductDetail(){
    this.router.navigate(['/producto/' + this.product.id])
  }

  isInShoopingCart(){
    var item = this.productsService.shooping_cart.find(item => item.id == this.product.id);
    return item;
  }
  

  async presentReedemCouponModal(){
    const modal = await this.modalController.create({
      component: ModalRedeemCouponPage,
      componentProps: {
        product: this.product
      }
    });
    modal.onDidDismiss()
    .then((response) => {
      if(response.data){
        this.product.additional_info = response.data;
        this.addProductShoopingCart();
      }
  });
    return await modal.present();
  }

  // Function to check if category is digital coupons
  checkCategory(){
    if(!this.productsService.validateNumberOfProducts(this.product, this.quantity)){
      this.toolsService.showErrorToast("No puedes agregar más de 10 productos al carrito")
      return
    }
    if(this.authService.isLogged){
      console.log(this.product)
      this.product = this.productsService.normaliseProduct(this.product, true, this.money, this.points, this.rangeValue, this.maxRangeValue, this.minRangeValue)
      if(this.product.brand_id || this.product.mega_coupon) // it is coupon
        this.presentReedemCouponModal()
      else if (this.is_insurance) // it is busqo insurance
        this.presentReedemInsuranceModal()
      else
        this.addProductShoopingCart()
    }
    else
      this.toolsService.showErrorToast("Debes ingresar para agregar un producto al carrito")
  }


  addProductShoopingCart(){
    if(this.product.coupon_used){
      // Validation coupon is not already used
      var coupon_exists = this.productsService.shooping_cart.find(item => item.coupon_used && item.coupon_used == this.product.coupon_used)
      if(coupon_exists){
        this.toolsService.showErrorToast("Ya estás usando este cupón en tu carrito")
        return
      }
    } 
    if(this.product.promotion) this.product.number_of_products = this.product.promotion.number_of_products
    this.toolsService.showSuccessToast('Producto agregado al carrito')
    this.product['quantity'] = this.quantity;
    this.productsService.addProduct(this.product);
  }

  removeProductShoopingCart(){
    this.productsService.removeProduct(this.product.id);
  }

  goToShoppingCart(){
    this.router.navigate(['/carrito-de-compras/'])
  }

  displayDisc(discount_value){
    try{
      return discount_value.indexOf('Dcto') >  -1
    }
    catch(e){
      return false
    }

  }

  displayDateInDays(end_date: string){
    return this.toolsService.displayDateInDays(end_date);
  }

  async presentReedemInsuranceModal() {
    const modal = await this.modalController.create({
      component: ModalRedeemInsurancePage,
      componentProps: {
        product: this.product
      }
    });
    modal.onDidDismiss()
      .then((response) => {
        if (response.data) {
          this.product.additional_info = response.data.additional_info;
          this.product.price = response.data.product.price; 
          this.product.custom_price_cash = response.data.product.custom_price_cash; 
          this.product.discount = response.data.product.discount
          this.addProductShoopingCart();
        }
      });
    return await modal.present();
  }

  /**
   * Get missing points to be able to buy product
   */
  getMissingPoints() {
    //Calculates missing points
    let product_price = this.product.price - this.product.discount
    let mPoints = product_price - this.authService.player_initial_data.points

    if(mPoints > 0) {
      //If the value of the product is grater than the user's points, then the quantity of missing points is assigned
      this.missing_points = mPoints
      this.missing_points_percentage = Math.round((this.missing_points / product_price) * 100);
    }

    let filled_points = product_price - this.missing_points
    this.progress_percentage = (filled_points / product_price) * 100;
  }


}
